
import { defineComponent, computed, PropType } from "vue";
import Multiselect from "../General/Multiselect.vue";
import Button from "../Buttons/Button.vue";
import axios from "axios";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading } from "@mdi/js";

export default defineComponent({
  props: {
    modelValue: {
      type: Number as PropType<any>,
      required: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const getProducts = async (query: string) => {
      return new Promise(async (resolve, reject) => {
        if (query.length <= 0) {
          return resolve([]);
        }
        try {
          const result = await axios.get(route("products.search"), {
            params: {
              query,
            },
          });

          resolve(result.data);
        } catch (error) {
          reject(error);
        }
      });
    };

    const productId = computed({
      get: (): number | null => props.modelValue,
      set: (v: number | null) => context.emit("update:modelValue", v),
    });

    const focusAmount = (e: Event) => {
      if (e?.target) {
        return;
      }

      document.getElementById("addProductAmount")?.focus();
    };

    const selectText = (e: FocusEvent) => {
      if (e.target instanceof HTMLInputElement) {
        e?.target?.select();
      }
    };

    return {
      productId,
      getProducts,
      focusAmount,
      selectText,
      loadingIcon: mdiLoading,
    };
  },
  components: { Multiselect, Button, SvgIcon },
});
